import { getLocaleDateFormat } from '@angular/common';
import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/shared/baseComponent';

@Component({
  selector: 'app-beaconlist',
  templateUrl: './beaconlist.component.html',
  styleUrls: ['./beaconlist.component.css']
})
export class BeaconlistComponent extends BaseComponent  implements OnInit {
  beacons: any = []
  beaconsdisplay: any = []
  beacongroups: any = []
  beacontypes: any = []
  organizations: any = []
  showInfo = false
  beacon: any =  { id: 0, uid: "",name: "", organizationid: 1}
  beaconFromName = ""
  beaconToName = ""
  sortArray:any = []
  scenbeaconsensors: any = []
  showConsistency = false
  constructor(injector: Injector) { super(injector) }

  async ngOnInit() {
    this.loader.show()
    await this.getData()
    this.loader.hide()
  }
  async getData() {
    this.scenbeaconsensors = await this.db.get("Scenariobeaconsensor", "GetScenarioBeaconSensorsWithNames")
    this.beacons = await this.db.get("Beacon", "getBeacons")
    this.beacons.forEach((beacon:any)=>{
      beacon.showScenarios = false
    })

    this.beacontypes = await this.db.get("beacon","getbeacontypes")
    this.organizations = await this.db.get("Organization", "getOrganizations")
    this.sort(this.organizations,"name")

    this.beacongroups =this.groupBy(this.beacons,"organizationId")
    this.beacongroups.forEach((bg:any)=>{
      bg.orgname = this.findObjectProp(this.organizations,"name",bg.key)
    })
    this.beaconsdisplay = this.beacons
    let a = 5
  }

  selectBeacon(beacon: any) {
    this.beacon = beacon
  }
  getPicUrl(bt:any){
    this.beacon.picUrl = bt.url
  }
  async submit() {
    this.loader.show();
    const resp = await this.db.post("Beacon", "postBeacon", this.beacon);
    await this.getData()
    this.loader.hide()
  }

  add() {
    this.beacon = { id: 0, uid: "",name: "", organizationid: 1}
  }

  async delete(beacon: any) {
    this.loader.show()
    const resp = await this.db.delete("Beacon", "deleteBeacon", { id: beacon.id })
    this.beacon = {}
    await this.getData()
    this.loader.hide()
  }

  sortDirectionId = true
  sortDirectionName = true
  sortCol(sWhat: string){
    if (sWhat == "id") this.sortDirectionId = this.sortUpDown(this.beacons,"id",this.sortDirectionId)
    if (sWhat == "name") this.sortDirectionName = this.sortUpDown(this.beacons,"name",this.sortDirectionName)
  }
  
  filter(id:any){
    if (id == 0){
      this.beaconsdisplay = this.beacons
      return
    }
    this.beaconsdisplay = []
    this.beacons.forEach((b:any)=>{
      if (b.organizationId == id){
        this.beaconsdisplay.push(b)
      }
    })
  }
  async copy(){
    let beacon = this.beacons.find((b:any) => b.name == this.beaconFromName)
    if (beacon != null){
      this.loader.show();
      beacon.id = 0
      beacon.name = this.beaconToName
      const resp = await this.db.post("Beacon", "postBeacon", beacon);
      await this.getData()
      this.loader.hide()
    }
  }
  showScenarios(beacon:any){
    beacon.showScenarios = true
  }
  hideScenarios(beacon:any){
    beacon.showScenarios = false
  }
  

}
